import { render, staticRenderFns } from "./cookies.vue?vue&type=template&id=136eabdc"
import script from "./cookies.vue?vue&type=script&lang=js"
export * from "./cookies.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {HyperSwitch: require('/root/containers/hermes_eshop/components/core/hyperSwitch.vue').default})
